var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcSavechat = function SvgIcSavechat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12c0 6.6 5.4 12 12 12 2.1 0 4-.5 5.7-1.5l5.4 1.4c.5.1 1-.3.9-.9l-1.4-5.4C23.5 16 24 14.1 24 12c0-6.6-5.4-12-12-12S0 5.4 0 12zm16.3-1.4-3.5 3.5c-.2.2-.4.3-.7.3s-.6-.1-.7-.3l-3.5-3.5c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L11 11V5.8c0-.6.4-1 1-1s1 .4 1 1V11l1.8-1.8c.4-.4 1-.4 1.4 0 .4.4.4 1 .1 1.4zM5.9 17.1c0-.6.4-1 1-1h10.2c.6 0 1 .4 1 1s-.4 1-1 1H6.9c-.6 0-1-.5-1-1z"
  })));
};
export default SvgIcSavechat;